import React, { useEffect, useState } from 'react';
import { Table, message, Modal } from 'antd';
import { DeleteOutlined, EditOutlined, EyeOutlined, PlusOutlined } from '@ant-design/icons';
import { useParams, useNavigate } from 'react-router-dom';
import { getSoilAnalysisByExploitation, deleteSoilAnalysis } from '../../../Utils/analysis/soilAnalysis';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import Loading from '../../Shared/Loading';



const { confirm } = Modal;

const SoilAnalysis = () => {
    const { exploitationId } = useParams();
    const navigate = useNavigate();
    const [soil, setSoil] = useState([]);
    const [loading, setLoading] = useState(true);
    const userRole = useSelector((state) => state.user.userRole.name);



    const userLink = () => {
        if (userRole === 'client') {
            return '/client';
        } else if (userRole === 'admin' || userRole === 'superadmin') {
            return '/admin';
        } else if (userRole === 'domain_manager') {
            return '/domain-manager';
        } else if (userRole === 'exploitation_manager') {
            return '/exploitation-manager';
        }
    };

    useEffect(() => {
        fetchSoil();
    }, [exploitationId]);

    const fetchSoil = async () => {
        try {
            const response = await getSoilAnalysisByExploitation(exploitationId);
            setSoil(response.data);
        } catch (error) {
            console.error('Erreur lors de la récupération des analyses de sol:', error);
            message.error('Échec de la récupération des analyses de sol');
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = (id) => {
        confirm({
            title: 'Êtes-vous sûr de vouloir supprimer cette analyse de sol ?',
            icon: <ExclamationCircleOutlined />,
            content: 'Cette action est irréversible.',
            okText: 'Oui',
            okType: 'danger',
            cancelText: 'Non',
            onOk: async () => {
                try {
                    await deleteSoilAnalysis(id);
                    message.success('Analyse supprimée avec succès');
                    fetchSoil();
                } catch (error) {
                    console.error('Erreur lors de la suppression de l\'analyse de sol:', error);
                    message.error('Échec de la suppression de l\'analyse');
                }
            },
        });
    };


    const handleEdit = (record) => {
        navigate(`/admin/exploitation/${exploitationId}/edit-soil-analysis/${record.analysis_id}`);
    };

    const handleView = (record) => {
        navigate(`${userLink()}/exploitation/${exploitationId}/view-soil-analysis/${record.analysis_id}`)
    };

    const handleCreateAnalysis = () => {
        navigate(`/admin/exploitation/${exploitationId}/create-soil-analysis`);
    };

    const columns = [
        { title: 'Échantillon', dataIndex: 'echantillon', key: 'echantillon' },
        { title: 'Date', dataIndex: 'date_realisation', key: 'date_realisation', render: (date) => new Date(date).toLocaleDateString() },
        { title: 'Laboratoire', dataIndex: 'laboratoire', key: 'laboratoire' },
        { title: 'Vanne associée', dataIndex: 'vanne', key: 'vanne' },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
                <span>
                    <EyeOutlined
                        onClick={() => handleView(record)}
                        className="text-green-500 text-2xl p-1 rounded-lg hover:bg-slate-200 cursor-pointer mr-4"
                    />

                    {(userRole === 'admin' || userRole === 'superadmin') &&
                        <>
                            <EditOutlined
                                onClick={() => handleEdit(record)}
                                className="text-blue-500 text-2xl p-1 rounded-lg hover:bg-slate-200 cursor-pointer mr-4"
                            />
                            <DeleteOutlined
                                onClick={() => handleDelete(record.analysis_id)}
                                className="text-red-500 text-2xl p-1 rounded-lg hover:bg-slate-200 cursor-pointer mr-4"
                            />
                        </>}
                </span>
            ),
        },
    ];


    if (loading) {
        return <Loading />;
    }


    return (
        <div className="p-4">

            <Table
                dataSource={soil}
                columns={columns}
                rowKey="id"
            />
            {(userRole === 'admin' || userRole === 'superadmin') &&
                <div
                    className="fixed flex items-center justify-center rounded-full shadow-lg bg-blue-500 w-16 h-16 bottom-10 right-10 text-white text-2xl cursor-pointer hover:bg-blue-600 transition duration-300 ease-in-out"
                    onClick={handleCreateAnalysis}
                >
                    <PlusOutlined className="text-3xl" />
                </div>}
        </div>
    );
};

export default SoilAnalysis;